"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Experts() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: portraitsRef,
    isVisible: portraitsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const instructors = [{
    name: "Physiothérapeute périnatale",
    specialty: "RÉEDUCATION DU PERINÉE",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/1709637129024-508966171.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/images.webp",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/images.webp"
  }, {
    name: "Monitrice de portage",
    specialty: "PORTAGE BÉBÉ",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/images.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/chef_claire.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/chef_claire.png-wvc-sizes"
  }, {
    name: "Consultante en sommeil bébé",
    specialty: "LE SOMMEIL DU NOURRISON",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/65312935a8823_bb-dort-beaucoup-768x543-1.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/65312935a8823_bb-dort-beaucoup-768x543-1.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/65312935a8823_bb-dort-beaucoup-768x543-1.png"
  }, {
    name: "Psychothérapeute ",
    specialty: "SANTE MENTALE EN POST-PARTUM",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/5c92ecc8497c72fc0d5abf18757b8eb0.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/1dd5a2ffe785d4b5764c7025baada7cc.webp",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/1dd5a2ffe785d4b5764c7025baada7cc.webp"
  }, {
    name: "Massothérapeute",
    specialty: "ATELIER MASSAGE BÉBÉ",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/images-2.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/images-2.webp",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/images-2.webp"
  }];
  return;
}